const baseUrl = `${process.env.VUE_APP_ZEYOS_PLATFORM}/remotecall/zeyos.portal.api`;
const shopDomain = process.env.VUE_APP_SHOP_DOMAIN

const config = {
  placeOrderTermsOfService: 'https://www.emeraldcs.co.uk/_files/ugd/60db90_7757b4474b4b49a9bd779aa2c4d92132.pdf',
  theme: 'light',
  documentTitle: 'Emeraldcs',
  title: 'Emeraldcs',
  logo: require('../assets/logo.png'),
  backToOriginButton: {
    label: {
      en: 'Back to Shop',
    },
    url: `https://${shopDomain}/`,
  },
  languages: [{
    value: 'en',
    label: 'English',
    img: require('../core/assets/flag-en.svg'),
  }],
  initial: {
    isExistingCustomer: 'n',
    validAccount: true,
    accountStatus: '',
    error: null,
  },
  defaultLanguage: 'en',
  events: {
    async onSubmit(form, formdata) {
      let response;

      function addUrlParamsToFormData(fd) {
        let params = new URLSearchParams(window.location.search);
        const redirectUrl = params.has('redirectUrl') ? params.get('redirectUrl') : '';
        if (['/checkout'].includes(redirectUrl)) {
          fd.set('redirectUrl', redirectUrl);
        }
        const locale = params.has('locale') ? params.get('locale') : '';
        if (locale) {
          fd.set('locale', locale);
        }
      }     

      if (form.isExistingCustomer === 'y') {
        const fd = new FormData();
        fd.set('username', form.sapCustno);
        fd.set('template', 'welcome');
        addUrlParamsToFormData(fd);
        response = await fetch(`${baseUrl}/reset`, {
            body: fd,
            method: 'POST',
          }
        );
      } else {
        addUrlParamsToFormData(formdata);
        response = await fetch(`${baseUrl}/register`, {
            body: formdata,
            method: 'POST',
          }
        );
      }

      if (response.ok) {
      } else {
        throw new Error(`Submission failed`);
      }
    },
  },
  submit: {
    label: {
      en: 'Submit registration',
      de: 'Registrierung abschicken'
    },
    title: {
      en: 'Welcome to Emeraldcs',
    },
    description: {
      en: 'Thank you very much for your registration. We are going to get back to you with your login details as soon as possible!',
    },
  },
  tabs: [
    {
      label: {
        en: 'Contact details',
      },
      id: 'masterdata',
      sections: [
        {
          type: 'form',
          cols: 2,
          label: {
            en: 'Please enter your customer number and your zip code for comparison.',
          },
          requires: {
            isExistingCustomer: 'y'
          },
          fields: [
            {
              id: 'sapCustno',
              type: 'text',
              label: {
                en: 'Customer number',
              },
              required: true
            },
            {
              id: 'sapCustnoZip',
              label: {
                en: 'Postalcode',
              },
              type: 'text',
              required: true
            }
          ]
        },
        {
          type: 'html',
          requires: {
            isExistingCustomer: 'y',
            validAccount: false,
          },
          content: {
            en: '<h2 class="account-not-found">We were not able to find your customer account.<br/> Please contact our support team at <a href="mailto:info@emeraldcs.com">info@emeraldcs.com</a></h2>',
          }
        },
        {
          type: 'form',
          cols: 2,
          label: {
            en: 'Please enter your contact details',
          },
          requires: {
            isExistingCustomer: 'n'
          },
          fields: [
            {
              id: 'gender',
              label: {
                en: 'Salutation',
              },
              type: 'select',
              required: true,
              options: [
                {value: 'mr', label: {en: 'Mr.', de: 'Herr'}},
                {value: 'mrs', label: {en: 'Mrs.', de: 'Frau'}}
              ]
            },
            {
              id: 'title',
              label: {
                en: 'Title',
              },
              type: 'text',
              required: false
            },
            {
              id: 'firstname',
              label: {
                en: 'Firstname',
                de: 'Vorname'
              },
              type: 'text',
              required: true
            },
            {
              id: 'lastname',
              label: {
                en: 'Lastname',
                de: 'Nachname'
              },
              type: 'text',
              required: true
            },
          ]
        },
        {
          type: 'form',
          cols: 2,
          label: {
            en: 'Business address',
          },
          requires: {
            isExistingCustomer: 'n'
          },
          fields: [
            {
              id: 'company',
              label: {
                en: 'Company name',
              },
              type: 'text',
              required: true
            },
            {
              id: 'country',
              label: {
                en: 'Country',
              },
              type: 'select',
              required: true,
              options: require('./countries.js')
            },
            {
              id: 'street',
              label: {
                en: 'Street',
              },
              type: 'text',
              required: true
            },
            {
              id: 'streetno',
              label: {
                en: 'Street no',
              },
              type: 'text',
              required: true
            },
            {
              id: 'postalcode',
              label: {
                en: 'Postalcode',
              },
              type: 'text',
              required: true
            },
            {
              id: 'city',
              label: {
                en: 'City',
              },
              type: 'text',
              required: true
            },
            {
              id: 'email',
              label: {
                en: 'E-mail',
              },
              type: 'email',
              required: true
            },
            {
              id: 'phone',
              label: {
                en: 'Phone',
              },
              type: 'phone',
              required: true
            },
            {
              id: 'taxid',
              label: {
                en: 'VAT ID',
              },
              type: 'text',
              validate: /^[A-Z]{2}[0-9]{4,}$/
            }
          ]
        },
        {
          type: 'html',
          requires: {
            isExistingCustomer: 'n',
            validAccount: false,
            error: '409: Mail-Adresse bereits vorhanden'
          },
          content: {
            en: '<h2 class="account-not-found">User with such email already exists</h2>',
          }
        },
      ],
      request: {
        url: `${baseUrl}/register?validate=1`,
        method: 'POST',
        header: {
          'x-auth': 'API-KEY'
        },
        mode: 'form',
        match(form) {
          return true;
        },
        success(response, form, ctx) {

          if (!response.result.valid) {
            form['validAccount'] = false;
            form['error'] = response.result.error
            return false;
          }

          form['validAccount'] = true;
          return true;
        },
        failure(result, form) {
          form['validAccount'] = false;
          return false;
        },
      }
    },
    {
      id: 'wrapup',
      label: {
        en: 'Registration',
      },
      sections: [
        {
          type: 'form',
          label: {
            en: 'We checked you account number.',
            de: 'Wir haben Ihre Kundendaten erfolgreich überprüft'
          },
          requires: {
            isExistingCustomer: 'y',
            validAccount: true,
          },
          fields: [
            {
              id: 'accountStatus',
              type: 'textarea',
              readonly: true,
            }
          ]
        },
        {
          type: 'form',
          fields: [
            {
              type: 'checkbox',
              id: 'terms',
              required: true,
              trueValue: 1,
              label: {
                en: 'I have read and accepted the <a target="_blank" href="https://www.emeraldcs.co.uk/_files/ugd/60db90_7757b4474b4b49a9bd779aa2c4d92132.pdf">Terms of Service</a>',
              }
            },
            {
              type: 'checkbox',
              id: 'privacy',
              required: true,
              trueValue: 1,
              label: {
                en: 'I have read and accepted the <a target="_blank" href="https://www.emeraldcs.co.uk/gdpr">Privacy Policy</a>',
              }
            }
          ]
        },
      ]
    }
  ]
}

export default config;
